module.exports = __webpack_public_path__ + "assets/img/clearwave-140.890d6ef9.webp";